export function parseNumberValue(inputValue: string | number) {
  if (typeof inputValue === 'number') return inputValue;

  // Удаляем все нечисловые символы, кроме точки/запятой и цифр
  const cleanedValue = inputValue.replace(/[^\d.,-eE]/g, '');
  const formattedValue = cleanedValue.replace(/[.,]/g, '.');

  const numberValue = parseFloat(formattedValue);

  return isNaN(numberValue) ? 0 : numberValue;
}
